export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    /* eslint-disable */
    if ($('#about-slider-one').length) {
      setTimeout(function() {
        var aboutSliderOne = $('#about-slider-one').lightSlider({
          item: 1,
          autoWidth: false,
          slideMove: 1, // slidemove will be 1 if loop is true
            
          // mode: 'fade',
          mode: 'slide',
          useCSS: true,
            
          speed: 800, //ms'
          auto: false,
          loop: false,
          slideEndAnimation: false,
          // pause: 2000,
            
          keyPress: false,
          controls: false,
          prevHtml: '',
          nextHtml: '',
            
          rtl: false,
          adaptiveHeight: false,
          slideMargin: 0,
            
          pager: true,
          gallery: false,
          thumbMargin: 30,
          currentPagerPosition: 'left',
            
          enableTouch: false,
          enableDrag: false,
          freeMove: false,
          swipeThreshold: 1,
            
          responsive : [ {
            breakpoint: 768,
            settings: {
                slideMargin: 60,
                enableTouch: true,
                enableDrag: true,
              },
          }],
            
          onBeforeStart: function (el) { },
          onSliderLoad: function (el) { },
          onBeforeSlide: function (el) {
            $('#about-section-two #about-slider-one-wrapper li .image-wrapper').addClass('active');
          },
          onAfterSlide: function (el) {
            $('#about-section-two #about-slider-one-wrapper li .image-wrapper').removeClass('active');

            let prevArrow = document.querySelector('#about-section-two .bws-arrow.prev');
            let nextArrow = document.querySelector('#about-section-two .bws-arrow.next');
            let currentSlide = $('#about-section-two #about-slider-one-wrapper .bws-slide.active').data('count');

            if (currentSlide == 1) {
              prevArrow.classList.add('disabled');
              nextArrow.classList.remove('disabled');
            } else if (currentSlide == pagerItems) {
              prevArrow.classList.remove('disabled');
              nextArrow.classList.add('disabled');
            } else {
              prevArrow.classList.remove('disabled');
              nextArrow.classList.remove('disabled');
            }
          },
          onBeforeNextSlide: function (el) {},
          onBeforePrevSlide: function (el) {}
        });
            
         let pagerItems = $('#about-section-two #about-slider-one-wrapper .lightSlider li.bws-slide').length;
         let currentSlide = $('.bws-slide.active').data('count', 1);

         $('#about-section-two .bws-pager .bws-arrow').click(function(e) {
           e.preventDefault();

           // Arrows move the slider next or prev
           if ($(this).hasClass('next')) {
             aboutSliderOne.goToNextSlide();

           
           } else if ($(this).hasClass('prev')) {
             aboutSliderOne.goToPrevSlide();
           }

         });
      }, 500);
    }

    if ($('#about-slider-three').length) {
      setTimeout(function() {
        var aboutSliderOne = $('#about-slider-three').lightSlider({
          item: 1,
          autoWidth: false,
          slideMove: 1, // slidemove will be 1 if loop is true
            
          // mode: 'fade',
          mode: 'slide',
          useCSS: true,
            
          speed: 800, //ms'
          auto: false,
          loop: false,
          slideEndAnimation: false,
          // pause: 2000,
            
          keyPress: false,
          controls: false,
          prevHtml: '',
          nextHtml: '',
            
          rtl: false,
          adaptiveHeight: false,
          slideMargin: 0,
            
          pager: true,
          gallery: false,
          thumbMargin: 30,
          currentPagerPosition: 'left',
            
          enableTouch: false,
          enableDrag: false,
          freeMove: false,
          swipeThreshold: 1,
            
          responsive : [ {
            breakpoint: 768,
            settings: {
                slideMargin: 60,
                enableTouch: true,
                enableDrag: true,
              },
          }],
            
          onBeforeStart: function (el) { },
          onSliderLoad: function (el) { },
          onBeforeSlide: function (el) {
            $('#about-section-two #about-slider-three-wrapper li .image-wrapper').addClass('active');
          },
          onAfterSlide: function (el) {
            $('#about-section-two #about-slider-three-wrapper li .image-wrapper').removeClass('active');

            let prevArrow = document.querySelector('#about-section-two .bws-arrow.prev');
            let nextArrow = document.querySelector('#about-section-two .bws-arrow.next');
            let currentSlide = $('#about-section-two #about-slider-three-wrapper .bws-slide.active').data('count');

            if (currentSlide == 1) {
              prevArrow.classList.add('disabled');
              nextArrow.classList.remove('disabled');
            } else if (currentSlide == pagerItems) {
              prevArrow.classList.remove('disabled');
              nextArrow.classList.add('disabled');
            } else {
              prevArrow.classList.remove('disabled');
              nextArrow.classList.remove('disabled');
            }
          },
          onBeforeNextSlide: function (el) {},
          onBeforePrevSlide: function (el) {}
        });
            
         let pagerItems = $('#about-section-two #about-slider-three-wrapper .lightSlider li.bws-slide').length;
         let currentSlide = $('.bws-slide.active').data('count', 1);

         $('#about-section-two .bws-pager .bws-arrow').click(function(e) {
           e.preventDefault();

           // Arrows move the slider next or prev
           if ($(this).hasClass('next')) {
             aboutSliderOne.goToNextSlide();

           
           } else if ($(this).hasClass('prev')) {
             aboutSliderOne.goToPrevSlide();
           }

         });
      }, 500);
    }

    // Section Two Mobile Slider
    if ($('#about-slider-mobile').length) {
            setTimeout(function() {
            var homeSliderTwo = $('#about-slider-mobile').lightSlider({
                item: 1,
                autoWidth: false,
                slideMove: 1, // slidemove will be 1 if loop is true
            
                // mode: 'fade',
                mode: 'slide',
                useCSS: true,
            
                speed: 800, //ms'
                auto: false,
                loop: false,
                slideEndAnimation: false,
                // pause: 2000,
            
                keyPress: false,
                controls: false,
                prevHtml: '',
                nextHtml: '',
            
                rtl: false,
                adaptiveHeight: false,
            
                pager: true,
                gallery: false,
                thumbMargin: 0,
                slideMargin: 60,
                currentPagerPosition: 'left',
            
                enableTouch: true,
                enableDrag: true,
                freeMove: false,
                swipeThreshold: 1,
            
                responsive : [ { }],
            
                onBeforeStart: function (el) { },
                onSliderLoad: function (el) { },
                onBeforeSlide: function (el) {
                  $('#about-section-two #about-slider-mobile-wrapper li .image-wrapper').addClass('active');
                },
                onAfterSlide: function (el) {
                  $('#about-section-two #about-slider-mobile-wrapper li .image-wrapper').removeClass('active');

                  let prevArrow = document.querySelector('#about-section-two .bws-arrow.prev');
                  let nextArrow = document.querySelector('#about-section-two .bws-arrow.next');
                  let currentSlide = $('#about-section-two #about-slider-mobile-wrapper .bws-slide.active').data('count');

                  if (currentSlide == 1) {
                    prevArrow.classList.add('disabled');
                    nextArrow.classList.remove('disabled');
                  } else if (currentSlide == pagerItems) {
                    prevArrow.classList.remove('disabled');
                    nextArrow.classList.add('disabled');
                  } else {
                    prevArrow.classList.remove('disabled');
                    nextArrow.classList.remove('disabled');
                  }
                },
                onBeforeNextSlide: function (el) {},
                onBeforePrevSlide: function (el) {}
            });
            

            let pagerItems = $('#about-section-two #about-slider-mobile-wrapper .lightSlider li.bws-slide').length;

            let currentSlide = $('.bws-slide.active').data('count', 1);

            $('#about-section-two .bws-pager .bws-arrow').click(function(e) {
              e.preventDefault();

              // Arrows move the slider next or prev
              if ($(this).hasClass('next')) {
                homeSliderTwo.goToNextSlide();

           
              } else if ($(this).hasClass('prev')) {
                homeSliderTwo.goToPrevSlide();

              }
            });
        }, 500);
    }

    $('form').addClass('wp-link');

    /* eslint-enable */

    let window_Width;
    $(window).on('load resize', function() {
        window_Width = $(window).width();
        return window_Width;
    });


    // Team List
    document.getElementById('the-salon-team-list').addEventListener('click', function(e) {
        e.preventDefault();

    //     // let current_item = e.target.parentElement.getAttribute('data-count');
    //     let list_length = document.querySelectorAll('#the-salon-team-list li').length;

    //     // Sets dimensions of bio descriptions
    //     let square_dimensions = document.querySelector('.team-square[data-count="item-1"]').getBoundingClientRect();
    //     let about_wrapper = document.querySelectorAll('.team-square .about-wrapper');
    //     let about_inner_wrapper = document.querySelectorAll('.team-square .about-inner-wrapper');
        

    //     if (e.target.tagName == 'A' && window_Width >= 769) {

    //         // Sets about width and height - and overflow settings
    //         for (let a = 0; a < about_wrapper.length; a++) {
    //             about_wrapper[a].style.width = square_dimensions.width + 'px';
    //             about_wrapper[a].style.height = square_dimensions.height + 'px';

    //             let updated_wrapper = about_inner_wrapper[a].getBoundingClientRect().height;

    //             // Checks if inner content is longer then wrapper - then adds clas
    //             if ((updated_wrapper) >= (about_wrapper[a].style.height.split('px')[0]) ) {
    //                 about_wrapper[a].classList.add('long-content');                
    //             }
    //         }
            
    //         // Resets all classes
    //         let all_li = document.querySelectorAll('.team-square');

    //         for (let a = 0; a < all_li.length; a++) {
    //             all_li[a].classList = "team-square";
    //         }


    //         let left_item = document.querySelector('[data-count="item-4"]').getBoundingClientRect().left;
    //         // let center_item = document.querySelector('[data-count="item-5"]').getBoundingClientRect().left;
    //         let right_item = document.querySelector('[data-count="item-6"]').getBoundingClientRect().left;
            
    //         // First Item
    //         if (e.target.parentElement.getAttribute('data-count') === "item-1" &&
    //             e.target.parentElement.classList.value != "team-square active-right"
    //             ) {
    //             e.target.parentElement.classList.add('active-right');
    //         } else if (e.target.parentElement.getAttribute('data-count') === "item-1" &&
    //                    e.target.parentElement.classList.value === "team-square active-right") {
    //             e.target.parentElement.classList.remove('active-right');
    //         }

    //         // Last Item
    //         if (e.target.parentElement.getAttribute('data-count') === "item-" + list_length &&
    //             e.target.parentElement.classList.value != "team-square active-left"
    //             ) {
    //             e.target.parentElement.classList.add('active-left');
    //             e.target.parentElement.previousElementSibling.classList.add('move-left');
                
    //         } else if (e.target.parentElement.getAttribute('data-count') === "item-" + list_length &&
    //                    e.target.parentElement.classList.value === "team-square active-left") {
    //             e.target.parentElement.classList.remove('active-left');
    //         }

    //         // If blank space is next item
    //         if (e.target.parentElement.classList.value === "team-square" &&
    //             e.target.parentElement.nextElementSibling.classList.contains('blank-space')) {
                    
    //             e.target.parentElement.previousElementSibling.classList.add('move-left');
    //             e.target.parentElement.classList.add('active-left');
    //         }
    //         else if (e.target.parentElement.classList.value === "team-square active-left" &&
    //             e.target.parentElement.nextElementSibling.classList.contains('blank-space')) {
                    
    //             e.target.parentElement.previousElementSibling.classList.remove('move-left');
    //             e.target.parentElement.classList.remove('active-left');
    //         } 


    //         // If blank space is Prev item
    //         if (e.target.parentElement.classList.value === "team-square" &&
    //             e.target.parentElement.previousElementSibling.classList.contains('blank-space')) {
    //             e.target.parentElement.nextElementSibling.classList.add('move-right');
    //             e.target.parentElement.classList.add('active-right');
    //         }
    //         else if (e.target.parentElement.classList.value === "team-square active-right" ) {
    //             e.target.parentElement.nextElementSibling.classList.remove('move-right');
    //             e.target.parentElement.classList.remove('active-right');
    //         }


    //         // Right Side Items
    //         if (e.target.parentElement.getBoundingClientRect().left == right_item &&
    //             e.target.parentElement.classList.value === "team-square") {
                
    //             e.target.parentElement.previousElementSibling.classList.add('move-left');
    //             e.target.parentElement.classList.add('active-left');
    //         }
    //         else if (e.target.parentElement.getBoundingClientRect().left == right_item &&
    //                  e.target.parentElement.classList.value === "team-square active-left") {
            
    //             e.target.parentElement.previousElementSibling.classList.remove('move-left');
    //             e.target.parentElement.classList.remove('active-left');
    //         }


    //         // Left Side Items
    //         if (e.target.parentElement.getBoundingClientRect().left == left_item &&
    //             e.target.parentElement.classList.value === "team-square") {

    //             e.target.parentElement.nextElementSibling.classList.add('move-right');
    //             e.target.parentElement.classList.add('active-right');
    //         }
    //         else if (e.target.parentElement.getBoundingClientRect().left == left_item &&
    //                  e.target.parentElement.classList.value === "team-square active-right") {

    //             e.target.parentElement.nextElementSibling.classList.remove('move-right');
    //             e.target.parentElement.classList.remove('active-right');
    //         }
    //     } else {
    //         e.preventDefault();
    //     }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/theSalon.js